import React, { Fragment, useCallback, useEffect, useState } from "react";

import { useSelector } from "react-redux";
import { useLikedFeedQuery } from "queries";
import { GifList, IUserList } from "components/feed/GifList";
import { ComboHeader } from "components/blocks/ComboHeader";
import { routes } from "routes";
import { ViewRegion } from "utils/metrics";
import { IAppState } from "store/app-state";

import { FooterAds } from "../../components/ads/FooterAds";
import { IGif, INicheMap } from "services/types";
import { filterGifsList } from "utils/filterGifsList";
import { filterNichesList } from "utils/filterNichesList";
import { filterUsersList } from "utils/filterUsersList";
import { ContentPageSkyscraperEnum } from "components/ads/config/units/contentPageSkyscraper";
import { WithSideAds } from "components/ads";
import "./FavouritesPage.scss";

export const FavouritesPage = (): JSX.Element => {
  const userName = useSelector((state: IAppState) => state.user.currentUser.username);
  const [topic, setTopic] = useState<string>("a");
  const [page, setPage] = useState<number>(1);
  const [pages, setPages] = useState<number>(1);
  const [totalGifs, setTotalGifs] = useState<number>(0);
  const [gifs, setGifs] = useState<IGif[]>([]);
  const [users, setUsers] = useState<IUserList>({});
  const [order, setOrder] = useState<string>("latest");
  const [tiles, setTiles] = useState<boolean>(true);
  const [niches, setNiches] = useState<INicheMap>({});

  const { isSuccess, isLoading, isError, data } = useLikedFeedQuery({
    count: 30,
    page: page,
    type: topic === "a" ? undefined : topic
  });

  useEffect(() => {
    document.title = "My Favourite Content | RedGIFs";
  });

  useEffect(() => {
    if (isSuccess && data !== undefined) {
      setPages(data.pages);
      setTotalGifs(data.total);
      setGifs(prev => filterGifsList(prev, data.gifs));
      setUsers(prev => filterUsersList(prev, data.users));

      if (data.niches) {
        setNiches(prev => filterNichesList(prev, data.niches));
      }
    }
  }, [isSuccess, data]);

  const reload = useCallback(() => {
    setGifs([]);
    setPage(1);
    setTotalGifs(0);
    window.scrollTo(0, 0);
  }, []);

  const changeOrder = useCallback((value: string): void => {
    setOrder(value);
    reload();
  }, [reload]);

  const fetchMore = useCallback(() => {
    setPage((prev) => prev + 1);
  }, []);

  const changeTopic = useCallback((value: string) => {
    setTopic(value);
    reload();
  }, [reload]);

  const changeMode = useCallback((tiles: boolean) => {
    setTiles(tiles);
  }, []);

  return (
    <Fragment>
      <WithSideAds
        leftAds={[
          ContentPageSkyscraperEnum.ContentPageSkyscraperL1,
        ]}
        rightAds={[
          ContentPageSkyscraperEnum.ContentPageSkyscraperR1,
        ]}
      >
        <div className="wide page exploreGifsPage">
          <ComboHeader
            back={routes.userCollections(userName)}
            text="Liked GIFs & Images"
          />

          <GifList
            ordering={false}
            topics={true}
            topic={topic}
            manage={false}

            order={order}
            tiles={tiles}
            gifs={gifs}
            users={users}
            niches={niches}
            totalLength={totalGifs}
            hasMore={page < pages}
            changeTopic={changeTopic}
            changeOrder={changeOrder}
            changeMode={changeMode}
            fetchMore={fetchMore}
            isError={isError}
            isLoading={isLoading}
            source={ViewRegion.Favourites}
          />
        </div>
      </WithSideAds>

      <FooterAds/>
    </Fragment>
  );
};
